import { SortOrder } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/sort.pb';
import { useListGroupedBookableAppointmentTypesInfiniteQuery } from '../queries/use-list-grouped-bookable-appointment-types-infinite-query';
import { useGetSchedulerV3FeatureFlagDetails } from './use-get-scheduler-v3-feature-flag-details';

export type ServiceTypePageConfig = {
  page: number;
  limit: number;
  searchValue?: string;
  sortBy?: 'display_name';
  sortDir?: SortOrder;
};

type UseGetServiceTypesV3InfiniteDataParamsType = {
  debouncedSearchValue?: string;
  selectedLocationId: string | undefined;
  pageConfig?: ServiceTypePageConfig;
  sourceTenantId?: string;
  isEnabled?: boolean;
  isIntegratedOffice?: boolean;
  limit?: number;
  fetchOnlyServiceTypes?: boolean;
};

export const useGetServiceTypesV3InfiniteData = ({
  selectedLocationId,
  debouncedSearchValue,
  sourceTenantId,
  pageConfig,
  isEnabled = true,
  isIntegratedOffice: _ = false,
  fetchOnlyServiceTypes = false,
}: UseGetServiceTypesV3InfiniteDataParamsType) => {
  const { isScheduleV3FlagEnabled } = useGetSchedulerV3FeatureFlagDetails();
  const pageLimit = pageConfig?.limit ?? 50;
  const sortParam = {
    ...(pageConfig?.sortBy && { sortBy: pageConfig.sortBy }),
    ...(pageConfig?.sortDir && { sortDir: pageConfig.sortDir }),
  };

  return useListGroupedBookableAppointmentTypesInfiniteQuery({
    request: {
      ...(pageLimit && { limit: pageLimit }),
      ...(pageConfig?.page && { page: pageConfig?.page }),
      ...(debouncedSearchValue && debouncedSearchValue.length >= 2 && { name: debouncedSearchValue }),
      locationId: selectedLocationId ?? '',
      sourceTenantIds: sourceTenantId ? [sourceTenantId] : undefined,
      ...(Object.keys(sortParam).length ? { sort: sortParam } : {}),
    },

    options: {
      enabled: !!isEnabled && !!selectedLocationId && isScheduleV3FlagEnabled,
      select: (data) => {
        return {
          ...data,
          pages: data.pages.map((page, index) => ({
            rows: fetchOnlyServiceTypes
              ? page.appointmentTypeGroups.flatMap((group) => group.bookableAppointmentTypes ?? [])
              : page.appointmentTypeGroups ?? [],
            bookableAppointmentTypes: page.appointmentTypeGroups.flatMap(
              (group) => group.bookableAppointmentTypes ?? []
            ),
            totalCount: page.totalAppointmentCount ?? 0,
            page: index + 1,
            totalPages: Math.ceil((page.totalAppointmentCount ?? 0) / pageLimit),
          })),
        };
      },
    },
  });
};
